import { FILTERS } from './evidenceFilters';

export default {
  path: '/evidences/kh-purchases',
  filters: [
    ...FILTERS,
  ],
};
